
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.734 6.275a.906.906 0 00-1.283 0L12 10.717 7.55 6.266a.907.907 0 10-1.284 1.283L10.716 12l-4.45 4.45a.908.908 0 001.283 1.284L12 13.284l4.45 4.45a.907.907 0 101.284-1.283L13.284 12l4.45-4.45a.912.912 0 000-1.275z"}})])
          )
        }
      }
    